import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import arrowDown from "assets/images/arrow-down-circle.svg";
import "./ShowProjectReportCard.scss";
import ProjectReviewTable from "../ProjectReviewTable";
import Loading from "components/GeneralComponents/Loading";
import { Link } from "react-router-dom";

const ShowProjectReportCard = ({ report, index }) => {
  // start MUI Accordion
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [usedItems, setUsedItems] = useState(null);
  const usedItemsInCustomFormat = () => {
    const temp = [];
    report.used_items.map((item, index) => {
      temp.push({
        itemName: report.used_items[index],
        itemUnit: report.units[index],
        itemValue: report.used_values[index],
      });
    });
    console.log("temp", temp);
    setUsedItems(temp);
  };
  useEffect(() => {
    usedItemsInCustomFormat();
  }, []);
  // end of MUI Accordion

  return (
    <Accordion
      className="mt-4"
      expanded={expanded === `panel${index + 1}`}
      onChange={handleChange(`panel${index + 1}`)}
    >
      <AccordionSummary
        expandIcon={<img src={arrowDown} width="30" height="30" />}
        aria-controls={`panel${index + 1}bh-content`}
        id={`panel${index + 1}bh-header`}
      >
        <Typography sx={{ width: "130px", flexShrink: 0, flexWrap: "wrap" }}>
          {report.project_name}
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>
          {report.address}
        </Typography>
        {
          report.status === "processing" &&
          <Typography sx={{ width: "70px", marginRight: "auto" }}>
            <Link
              to={`/projects/projectsDetails?employer=${report.project_name}&reportId=${report.id}&offlineMode=false&editingMode=true`}
            >
              ویرایش
            </Link>
          </Typography>
        }
      </AccordionSummary>
      <AccordionDetails>
        {usedItems ? (
          <ProjectReviewTable
            isOfflineMode={false}
            employerName={report.project_name}
            startTime={report.start_time}
            endTime={report.end_time}
            selectedItems={usedItems}
            description={report.description}
            employerSignature={report.employer_signature}
            technicianSignature={report.technician_signature}
            isReviewReport={true}
            dateOfReport={report.created_at}
          />
        ) : (
          <Loading />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default ShowProjectReportCard;